<template>
  <div>
    <div id="PengajuanManagement">
      <div class="row mb-4">
        <div class="col-sm-8">
          <h2>Dokumen Pendukung</h2>
        </div>
        <!-- <div class="col-sm-4 text-right">
          <b-button variant="primary" class="btn btn-custom theme-color text-white px-4 rounded-0" @click="downloadPengajuanMitra">Download</b-button>
        </div> -->
      </div>
      <div class="row no-gutters mb-4">
          <div class="col-md-9">
              <label>Filter Berdasarkan Tanggal :</label>
              <div class="form-inline">
                  <input name="start_date" type="text" onfocus="(this.type='date')" placeholder="Mulai Dari"
                      class="form-control mr-2">
                  <input name="end_date" type="text" onfocus="(this.type='date')" placeholder="Sampai Dengan"
                      class="form-control mr-2">
                  <b-button class="btn btn-custom btn-sm" @click="applyDateFilter">Filter</b-button>
              </div>
          </div>
      </div>

      <div class="overflow-auto">
        <b-table id="pengajuan-table" responsive="true" :items="pengajuanItems" :fields="pengajuanFields"
          :current-page="currentPagePengajuan" :per-page="perPagePengajuan">
          <template v-slot:cell(id_transaksi)="data">
            <div>{{ data.item.id }}</div>
          </template>
          <template v-slot:cell(product)="data">
            <div>{{ data.item.product.nama_produk }}</div>
          </template>
          <template v-slot:cell(product_category)="data">
            <div>{{ data.item.product.product_category.name }}</div>
          </template>
          <template v-slot:cell(funder)="data">
            <div>{{ data.item.funder.name }}</div>
          </template>
          <template v-slot:cell(setoran_awal)="data">
            <div>Rp. {{ new Intl.NumberFormat().format(data.item.setoran_awal) }}</div>
          </template>
          <template v-slot:cell(is_active_aro)="data">
            <div :style="{ color: data.item.is_active_aro ? 'green' : 'red' }">
              {{ data.item.product.product_category_id == 1 ? (data.item.is_active_aro ? 'Aktif' : 'Tidak Aktif') : '-'
              }}
            </div>
          </template>
          <template v-slot:cell(status_pengajuan)="data">
            <div>{{ data.item.status_pengajuan.name }}</div>
          </template>
          <template v-slot:cell(status_pembayaran)="data">
            <div>{{ data.item.status_pengajuan_id == 6 ? (data.item.latest_payment_confirmation ?
              convertStatusPembayaran(data.item.latest_payment_confirmation.status) : 'Menunggu Pembayaran') : '-' }}
            </div>
          </template>
          <template v-slot:cell(status_document)="data">
            <div>{{ data.item.status_pengajuan_id == 6 ? (data.item.document ?
              convertStatusDocument(data.item.document.status) : '-') : '-'}}</div>
          </template>
          <template v-slot:cell(aksi)="data">
            <b-button v-if="data.item.status_pengajuan_id == 6 && data.item.latest_payment_confirmation && data.item.latest_payment_confirmation.status == 'approved' && !data.item.document" @click="uploadDoc(data.item)"
              type="button" variant="success" class="btn btn-custom theme-color">
              {{ data.item.product.product_category_id == 1 ? 'Unggah Bilyet dan Resi' : 'Unggah Rekening dan Resi' }}
            </b-button>
          </template>
        </b-table>
      </div>

      <b-modal size="md" v-model="uploadDocumentModal" hide-footer hide-header>
        <div class="d-block text-center">
          <h3>{{ modalDocTitle }}</h3>
        </div>
        <b-form @submit.prevent="handleSubmit">
          <template v-if="category === 1">
            <!-- Form for category 1 -->
            <b-form-group label="Nomor Bilyet" label-for="nomor_bilyet">
              <b-form-input id="nomor_bilyet" v-model="form_upload.nomor_bilyet" placeholder="Masukkan Nomor Bilyet"
                required></b-form-input>
            </b-form-group>
            <b-form-group label="Unggah Bilyet" label-for="upload_bilyet">
              <b-form-file id="upload_bilyet" v-model="form_upload.upload_bilyet" accept="image/*"></b-form-file>
            </b-form-group>
          </template>

          <template v-if="category === 2">
            <!-- Form for category 2 -->
            <b-form-group label="Nomor Rekening" label-for="nomor_rekening">
              <b-form-input id="nomor_rekening" v-model="form_upload.nomor_rekening"
                placeholder="Masukkan Nomor Rekening" required></b-form-input>
            </b-form-group>
            <b-form-group label="Unggah Halaman Depan Buku Tabungan" label-for="upload_rekening">
              <b-form-file id="upload_rekening" v-model="form_upload.upload_rekening" accept="image/*"></b-form-file>
            </b-form-group>
          </template>

          <b-form-group label="Nomor Resi" label-for="nomor_resi">
            <b-form-input id="nomor_resi" v-model="form_upload.nomor_resi"
              placeholder="Masukkan Nomor Resi"></b-form-input>
          </b-form-group>
          <b-form-group label="Unggah Resi" label-for="upload_resi">
            <b-form-file id="upload_resi" v-model="form_upload.upload_resi" accept="image/*"></b-form-file>
          </b-form-group>
        </b-form>
        <div v-if="!changingStatus" class="row">
          <div class="col"
            v-if="category === 2 && form_upload.nomor_rekening && form_upload.upload_rekening && form_upload.nomor_resi && form_upload.upload_resi">
            <b-button class="mt-3 btn-custom success" block @click="confirmUpload">Unggah</b-button>
          </div>
          <div class="col">
            <b-button class="mt-3 btn-custom cancel" block @click="uploadDocumentModal = false">Batal</b-button>
          </div>
          <div class="col"
            v-if="category === 1 && form_upload.nomor_bilyet && form_upload.upload_bilyet && form_upload.nomor_resi && form_upload.upload_resi">
            <b-button class="mt-3 btn-custom success" block @click="confirmUpload">Unggah</b-button>
          </div>
        </div>

        <!-- Jika masih dalam proses perubahan status -->
        <div v-else class="row">
          <div class="col text-center">
            <b-spinner variant="primary"></b-spinner>
          </div>
        </div>
      </b-modal>
      <h2 v-if="loaded == false" class="text-center"><b-spinner variant="warning"></b-spinner></h2>
      <b-pagination align="center" :total-rows="rowsPengajuan" :per-page="perPagePengajuan"
        aria-controls="pengajuan-table" v-model="currentPagePengajuan"></b-pagination>


      <!-- Modals and other components -->
      <b-modal size="sm" v-model="successModal" hide-footer hide-header>
        <div class="d-block text-center">
          <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
          <h3>Dokumen berhasil diunggah</h3>
        </div>
        <div class="row">
          <div class="col">
            <b-button class="mt-3" block @click="successModal = false">Tutup</b-button>
          </div>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
import Pengajuan from '../../api/pengajuan.js';

const pengajuanFields = [
  { key: 'id_transaksi', label: 'ID Transaksi', sortable: false },
  { key: 'product', label: 'Nama Produk', sortable: true },
  { key: 'product_category', label: 'Kategori Produk', sortable: true },
  { key: 'funder', label: 'Nama Nasabah', sortable: true },
  { key: 'setoran_awal', label: 'Setoran Awal', sortable: true },
  { key: 'is_active_aro', label: 'ARO', sortable: false },
  { key: 'status_pengajuan', label: 'Status Pengajuan', sortable: true },
  { key: 'status_pembayaran', label: 'Status Pembayaran', sortable: true },
  { key: 'status_document', label: 'Status Bilyet', sortable: true },
  { key: 'aksi', label: 'Aksi' }
];

export default {
  name: "DokumenPendukung",
  data() {
    return {
      pengajuanItems: [],
      pengajuanFields: pengajuanFields,
      perPagePengajuan: 5,
      currentPagePengajuan: 1,
      uploadDocumentModal: false,
      form_upload: {
        pengajuan_id: null,
        nomor_bilyet: "",
        upload_bilyet: null,
        nomor_resi: "",
        upload_resi: null,
        nomor_rekening: "",
        upload_rekening: null,
      },
      successModal: false,
      modalTitle: '',
      modalDocTitle: '',
      changingStatus: false,
      loaded: false,
      mitra_bank_id: '',
      category: '',
    };
  },
  computed: {
    rowsPengajuan() {
      return this.pengajuanItems.length;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      Pengajuan.pengajuanMitra()
        .then((res) => {
          this.pengajuanItems = res.data.data.sort((a, b) => {
            const statusA = a.document ? a.document : '';
            const statusB = b.document ? b.document : '';
            if (!statusA) return -1;
            if (statusB) return 1;
            return 0;
          });
          this.loaded = true;
        })
        .catch((err) => console.log(err));
    },
    uploadDoc(item) {
      this.form_upload.pengajuan_id = item.id;
      this.category = item.product.product_category_id;
      this.modalDocTitle = this.category === 1
        ? "Unggah Bilyet Dan Resi Pengiriman"
        : "Unggah Tabungan Dan Resi Pengiriman";
      this.uploadDocumentModal = true;
    },
    confirmUpload() {
      this.changingStatus = true;

      const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => reject(new Error("Error reading file"));
          reader.readAsDataURL(file);
        });
      };

      const filePromises = [
        this.form_upload.upload_bilyet
          ? convertToBase64(this.form_upload.upload_bilyet).then((base64) => {
            this.form_upload.upload_bilyet = base64;
          })
          : Promise.resolve(),
        this.form_upload.upload_resi
          ? convertToBase64(this.form_upload.upload_resi).then((base64) => {
            this.form_upload.upload_resi = base64;
          })
          : Promise.resolve(),
        this.form_upload.upload_rekening
          ? convertToBase64(this.form_upload.upload_rekening).then((base64) => {
            this.form_upload.upload_rekening = base64;
          })
          : Promise.resolve(),
      ];

      Promise.all(filePromises)
        .then(() => {
          const formData = {
            pengajuan_id: this.form_upload.pengajuan_id,
            nomor_resi: this.form_upload.nomor_resi,
            upload_resi: this.form_upload.upload_resi,
            ...(
              this.category === 1
                ? { nomor_bilyet: this.form_upload.nomor_bilyet, upload_bilyet: this.form_upload.upload_bilyet }
                : { nomor_bilyet: this.form_upload.nomor_rekening, upload_bilyet: this.form_upload.upload_rekening }
            )
          };

          return Pengajuan.uploadDocumentPengajuan(formData);
        })
        .then((res) => {
          if (res.data.meta.code === 200) {
            this.uploadDocumentModal = false;
            this.successModal = true;
            this.loadData();
          }
          this.changingStatus = false;
        })
        .catch((err) => {
          console.log(err);
          this.changingStatus = false;
        });
    },
    convertStatusPembayaran(status) {
      switch (status) {
        case 'pending':
          return 'Menunggu Konfirmasi Mitra';
        case 'approved':
          return 'Disetujui Mitra';
        case 'rejected':
          return 'Ditolak Mitra';
        default:
          return '';
      }
    },
    applyDateFilter() {
      return;
    },
    convertStatusDocument(status) {
      switch (status) {
        case 'mitra_uploaded':
          return 'Dikirim Mitra';
        case 'funder_received':
          return 'Diterima Funder';
        case 'funder_uploaded':
          return 'Dikirim Funder';
        case 'mitra_received':
          return 'Diterima Mitra'
        default:
          return '';
      }
    }
    // downloadPengajuanMitra() {
    //   Pengajuan.downloadPengajuanMitra()
    //     .then((response) => {
    //       const url = window.URL.createObjectURL(new Blob([response.data]));
    //       const link = document.createElement('a');
    //       link.href = url;
    //       link.setAttribute('download', 'pengajuan_mitra.csv');
    //       document.body.appendChild(link);
    //       link.click();
    //       link.remove();
    //     })
    //     .catch((error) => {
    //       console.error('Error downloading the file:', error);
    //     });
    // }
  },
};
</script>

<style scoped>
.overflow-auto {
  overflow-x: auto;
}

.b-table {
  min-width: 800px;
}
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.cancel:hover {
  background-color: #fd0000;
  color: #ffffff;
}
.success:hover {
  background-color: #00b300;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dokumen-pendukung.vue